<section class="content">
  <span [class]="spanClass()">{{ isAgentProcess() ? '' : translationText() }} {{ agentName() }}</span>
</section>
